export default __webpack_public_path__ + "static/media/医疗险.42f2973d.jpg";